<div class="inner">
  <div class="layer-title">
    <h3 class="text-center">{{data.title}}</h3>
  </div>
  <p [innerHTML]="data.description"></p>
</div>
<div class="btn_area only">
  <a class="btn btn_type1 btn_layerclose" (click)="onClose()">Close</a>
  <a class="btn btn_type1 btn_layerclose" (click)="onConfirm()">Confirm</a>
</div>
